import React from 'react';

import { cn } from '../lib/utils';

export interface PersonName {
  firstName?: string | null;
  lastName?: string | null;
  email: string;
}

/** "Pat Lee", or '' when the person has no name on record. */
export function personDisplayName(person: Pick<PersonName, 'firstName' | 'lastName'>): string {
  return [person.firstName, person.lastName]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(' ');
}

export interface PersonCellProps extends PersonName {
  className?: string;
}

/**
 * A person, wherever one is identified (My Organization members, System Admin
 * users, member lists in dialogs): the name with the email beneath it, or the
 * email alone when there is no name — never an italic "No name" placeholder.
 */
export const PersonCell: React.FC<PersonCellProps> = ({ firstName, lastName, email, className }) => {
  const name = personDisplayName({ firstName, lastName });
  return (
    <div className={cn('min-w-0', className)}>
      <p className="truncate font-medium">{name || email}</p>
      {name ? <p className="truncate text-xs text-muted-foreground">{email}</p> : null}
    </div>
  );
};
